<template>
    <div>
        <template v-if="!componentIsLoading">
            <h5>Adresse de comptabilité</h5>

            <errors :items="errors"
                @errors-closed="resetErrors"
            ></errors>

            <form v-if="fields.length > 0">
                <div class="form-group">
                    <label>{{ getField('accounting_address.same_as_existing_address').label }}</label>

                    <custom-select :field="getField('accounting_address.same_as_existing_address')" 
                        :value="socialCertificate.accounting_address.same_as_existing_address"
                        :field_idx="'accounting_address.same_as_existing_address'"
                        @field-updated="$emit('field-updated', $event)">
                    </custom-select>
                </div>

                <div v-show="'other' == socialCertificate.accounting_address.same_as_existing_address">
                    <div class="form-group">
                        <label>{{ getField('accounting_address.corporation_name').label }}</label>

                        <custom-text :field="getField('accounting_address.corporation_name')" 
                            :value="socialCertificate.accounting_address.corporation_name" 
                            :field_idx="'accounting_address.corporation_name'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-text>
                    </div>

                    <div class="form-group">
                        <label>{{ getField('accounting_address.first_name').label }}</label>

                        <custom-text :field="getField('accounting_address.first_name')" 
                            :value="socialCertificate.accounting_address.first_name" 
                            :field_idx="'accounting_address.first_name'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-text>
                    </div>
                    
                    <div class="form-group">
                        <label>{{ getField('accounting_address.last_name').label }}</label>

                        <custom-text :field="getField('accounting_address.last_name')" 
                            :value="socialCertificate.accounting_address.last_name" 
                            :field_idx="'accounting_address.last_name'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-text>
                    </div>

                    <div class="form-group">
                        <label>{{ getField('accounting_address.street_line1').label }}</label>

                        <custom-text :field="getField('accounting_address.street_line1')" 
                            :value="socialCertificate.accounting_address.street_line1" 
                            :field_idx="'accounting_address.street_line1'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-text>
                    </div>

                    <div class="form-group">
                        <label>{{ getField('accounting_address.street_line2').label }}</label>

                        <custom-text :field="getField('accounting_address.street_line2')" 
                            :value="socialCertificate.accounting_address.street_line2" 
                            :field_idx="'accounting_address.street_line2'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-text>
                    </div>

                    <div class="form-group">
                        <label>{{ getField('accounting_address.zipcode').label }}</label>

                        <custom-text :field="getField('accounting_address.zipcode')" 
                            :value="socialCertificate.accounting_address.zipcode" 
                            :field_idx="'accounting_address.zipcode'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-text>
                    </div>

                    <div class="form-group">
                        <label>{{ getField('accounting_address.city').label }}</label>

                        <custom-text :field="getField('accounting_address.city')" 
                            :value="socialCertificate.accounting_address.city" 
                            :field_idx="'accounting_address.city'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-text>
                    </div>

                    <div class="form-group" v-if="'US' == socialCertificate.accounting_address.country">
                        <label>{{ getField('accounting_address.state').label }}</label>

                        <custom-select :field="getField('accounting_address.state')" 
                            :value="socialCertificate.accounting_address.state"
                            :field_idx="'accounting_address.state'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-select>
                    </div>
                    
                    <div class="form-group">
                        <label>{{ getField('accounting_address.country').label }}</label>

                        <custom-select :field="getField('accounting_address.country')" 
                            :value="socialCertificate.accounting_address.country"
                            :field_idx="'accounting_address.country'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-select>
                    </div>
                </div>
            </form>

            <div class="buttons clearfix">
                <button class="btn btn-success btn-sm pull-right"
                    @click="validateCurrentStep"
                >
                    Suivant
                </button>
            </div>
        </template>

        <component-loader v-else></component-loader>
    </div>
</template>

<script>
    import api from 'store/api'
    import formStepMixin from "mixins/socialCertificateFormStep";
    import Errors from './Errors'
    import CustomSelect from "components/Forms/Elements/Select"
    import CustomText from "components/Forms/Elements/Text"
    import ComponentLoader from 'components/ComponentLoader'

    export default {
        mixins: [
            formStepMixin
        ],

        components: {
            Errors,
            CustomSelect,
            CustomText,
            ComponentLoader
        },

        props: {
            socialCertificate: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                componentIsLoading: false,
                fields: [],
            }
        },

        created() {
            this.componentIsLoading = true

            api.getCustomerSocialCertificateEditionSchema(this.profile.id, 'accounting_address')
                .then((response) => {
                    if (response.data.schema && response.data.schema.hasOwnProperty('fields')) {
                        this.fields = response.data.schema.fields
                    }

                    this.componentIsLoading = false
                })
        },

        methods: {
            validateCurrentStep() {
                if (this.validateAddressStep('accounting')) {
                    this.$emit('current-step-changed', 'social-address')
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/SocialCertificate/EditionForm/AccountingAddressStep.vue